﻿import controller from '../../../../Resources/Scripts/_Shared/controller';
import { paramsToObject } from '../../../../Resources/Scripts/_Shared/history'
import React from 'react';
import ReactDOM from 'react-dom';

import PermitForm from './LandlordPermitForm'

function landlordpermitoverlay(context) {
  let requestAnimation = false;

  function init() {
    initMaxHeight();
    window.addEventListener('resize', initMaxHeight);
    window.addEventListener('orientationchange', initMaxHeight);

    context.addEventListener('click', function(event) {
      if (event.target.dataset.closeOverlay) {
        closeOverlay(context);
			}
    });
  }

  function initMaxHeight() {
    if (!requestAnimation) {
      window.requestAnimationFrame(function() {
        context.style.maxHeight = `${window.innerHeight}px`;
        requestAnimation = false;
      });
    }

    requestAnimation = false;
	}

  return {
    init
  };
}

export function appendContent(context, data, html = '') {
  const contentWrapper = context.querySelector('[data-overlay-content]');

	if (html) {
    contentWrapper.innerHTML = html;
    context.removeAttribute('aria-busy');

    controller.parse(contentWrapper);
	} else if (data && data.error) {
    context.removeAttribute('aria-busy');
	}
}

export function openOverlay(context, data = {}) {
  const htmlElement = document.querySelector('html');
  htmlElement.classList.add('map-overlay-active');

  const headingContainer = context.querySelector('header h1');
  const subHeadingContainer = context.querySelector('header h2');

  if (data.heading)
    headingContainer.innerHTML = data.heading;

  if (data.subHeading)
    subHeadingContainer.innerHTML = data.subHeading;

  if (data.hideLoader === null || data.hideLoader === undefined || data.hideLoader === false)
    context.setAttribute('aria-busy', 'true');

  context.removeAttribute('aria-hidden')
  context.removeAttribute('inert');

  const appContainer = context.querySelector('[data-app-container]');
  const appConfig = controller.getConfig(context);

  ReactDOM.render(<PermitForm lang={appConfig.localization} context={context} permitId={data.permitId} customerNumber={data.customerNumber} />, appContainer);
}

export function closeOverlay(context, data = {}) {
  const htmlElement = document.querySelector('html');
  htmlElement.classList.remove('map-overlay-active');
  
  /* Fix for aria-hidden issue
   * Move focus outside the overlay
   */
  const minaDigitalaLink = document.querySelector('a[data-portals-navigation="MyAimoParkDigitalPermitsPage"]');
  if (minaDigitalaLink) {
    minaDigitalaLink.focus({ preventScroll: true });
  } else if (document.activeElement && context.contains(document.activeElement)) {
    document.body.focus({ preventScroll: true });
  }

  context.setAttribute('aria-hidden', 'true');
  context.setAttribute('inert', '');
  context.removeAttribute('aria-busy');

  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete('permitId');

  let newUrl = window.location.origin + window.location.pathname;
  if (urlParams.toString().length > 0)
    newUrl += '?' + urlParams.toString()

  history.replaceState(paramsToObject(urlParams), document.title, newUrl);

  setTimeout(function () {
    const headingContainer = context.querySelector('header h1');
    const subHeadingContainer = context.querySelector('header h2');
    const appContainer = context.querySelector('[data-app-container]');

    headingContainer.innerHTML = '';
    subHeadingContainer.innerHTML = '';

    ReactDOM.unmountComponentAtNode(appContainer);
  }, 500);
}

controller.add('landlord-permit-overlay', landlordpermitoverlay);
